import { render, staticRenderFns } from "./subjectFeedbackDetail.vue?vue&type=template&id=8466f976&scoped=true&"
import script from "./subjectFeedbackDetail.vue?vue&type=script&lang=js&"
export * from "./subjectFeedbackDetail.vue?vue&type=script&lang=js&"
import style0 from "./subjectFeedbackDetail.vue?vue&type=style&index=0&id=8466f976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8466f976",
  null
  
)

export default component.exports